import { motion } from 'framer-motion';

export default function WithMotion<T>(Component: React.ComponentType<T>) {
  return (props: T) => (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <Component {...props} />
    </motion.div>
  );
}
